/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyExpensiveMeetingQueryVariables = {
    orgRelayId: string;
    calendarIds: Array<string | null>;
};
export type SuggestionBodyExpensiveMeetingQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyExpensiveMeeting_org">;
    } | null;
};
export type SuggestionBodyExpensiveMeetingQuery = {
    readonly response: SuggestionBodyExpensiveMeetingQueryResponse;
    readonly variables: SuggestionBodyExpensiveMeetingQueryVariables;
};



/*
query SuggestionBodyExpensiveMeetingQuery(
  $orgRelayId: ID!
  $calendarIds: [String]!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...SuggestionBodyExpensiveMeeting_org_3nh1j1
    }
    id
  }
}

fragment SuggestionBodyExpensiveMeeting_org_3nh1j1 on Org {
  id
  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
    __typename
    ... on PersonList {
      list {
        __typename
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        userId
        isUser
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v3 = [
        {
            "kind": "Variable",
            "name": "calendarIds",
            "variableName": "calendarIds"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "SuggestionBodyExpensiveMeetingQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": (v3 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "SuggestionBodyExpensiveMeeting_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "SuggestionBodyExpensiveMeetingQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emails",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserProfile",
                                                            "kind": "LinkedField",
                                                            "name": "profile",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "givenName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "familyName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalImageUrl",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isYou",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "userId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isUser",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonList",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f51fb4c8062539b98fac179bf291b84d",
            "id": null,
            "metadata": {},
            "name": "SuggestionBodyExpensiveMeetingQuery",
            "operationKind": "query",
            "text": "query SuggestionBodyExpensiveMeetingQuery(\n  $orgRelayId: ID!\n  $calendarIds: [String]!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...SuggestionBodyExpensiveMeeting_org_3nh1j1\n    }\n    id\n  }\n}\n\nfragment SuggestionBodyExpensiveMeeting_org_3nh1j1 on Org {\n  id\n  personsByCalendarIdsErrorable(calendarIds: $calendarIds) {\n    __typename\n    ... on PersonList {\n      list {\n        __typename\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        userId\n        isUser\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'dbdd6b44deb6ab7e6d244b0d3540b3bd';
export default node;
